import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ReservationService } from '@modules/car-booking/services/reservation-service/reservation.service';
import { PaymentData, BookedRoomsList } from '@modules/car-booking/models/payment-data.model';

@Component({
  selector: 'app-price-details-checkout',
  templateUrl: './price-details-checkout.component.html',
  styleUrls: ['./price-details-checkout.component.scss'],
  animations: [
    trigger('slideDownUp', [
      state('void', style({ height: '0', opacity: '0' })),
      state('*', style({ height: '*', opacity: '1' })),
      transition(':enter, :leave', [animate('0.3s ease-out')]),
    ]),
    trigger('rotateAnimation', [
      state('open', style({ transform: 'rotate(0deg)' })),
      state('closed', style({ transform: 'rotate(180deg)' })),
      transition('open <=> closed', animate('0.3s ease-out')),
    ]),
  ],
})
export class PriceDetailsCheckoutComponent {
  @Input() price: any;
  isShowTax: boolean = false;
  price_details: PaymentData;
  totalPrice: number;
  isShowTaxesCharges: boolean = true;

  constructor(private reservationService: ReservationService) {
    this.reservationService.getDataRespone().subscribe((data: PaymentData) => {
      this.price_details = data;
    });

    this.totalPrice = this.price_details?.booked_rooms_list?.reduce(
      (totalPrice, room) => {
        return totalPrice + room.final_price_room;
      },
      0
    );
  }

  public formatCurrency(price: number) {
    return price.toLocaleString('en-US');
  }

  handleToggleDropdown(): void {
    this.isShowTax = !this.isShowTax;
  }

  formatDollar(price: number) {
    return new Intl.NumberFormat('en-US', {
      style: 'decimal',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(price);
  }

  toggleTaxesCharges() {
    this.isShowTaxesCharges = !this.isShowTaxesCharges;
  }
}
